import { makeStyles, tokens } from '@fluentui/react-components';

export const usePriceLineStyles = makeStyles({
    root: {
        display: 'grid',
        gridTemplateColumns: '.8fr 1fr',
        width: '100%',
        height: '45px',
        alignContent: 'center',
        '@media screen and (max-width: 480px)': {
            gridTemplateColumns: '1fr 1fr'
        }
    },
    title: {
        fontSize: tokens.fontSizeBase400,
        fontWeight: tokens.fontWeightBold,
        lineHeight: tokens.lineHeightBase500
    },
    pricingContainer: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr .1fr',
        '@media screen and (max-width: 780px)': {
            gridTemplateColumns: '1fr 1fr'
        }
    },
    pricingItem: {
        display: 'flex',
        justifyContent: 'center'
    }
});
